import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const UniversityService = {
  getList: async () => {
    const response = await apiService.get("/universities");
    console.log(response);
    return response.data;
  },
  create: async (data) => {
    const response = await apiService.post("/universities", data);
    return response.data;
  },
  getbyId: async (id) => {
    console.log("called");
    const response = await apiService.get(`/universities/${id}`);
    console.log("called again");
    console.log(response.data);
    return response.data;
  },
  update: async (id, updateData) => {
    try {
      const response = await apiService.put(`/universities/${id}`, updateData);
      return response.data;
    } catch (error) {
      console.error("Error updating Universities", error);
      throw error;
    }
  },
  delete: async (id) => {
    const response = await apiService.delete(`/universities/${id}`);
    return response.data;
  },
  checkSlug: async (data) => {
    const response = await apiService.post("/universities/check-slug", data);
    return response.data;
  },
};
export default UniversityService;
